import React from 'react';
import { Item, Segment, Dropdown, Button } from 'semantic-ui-react';

const View = ({ options, onInputChange, loading, onClaimStateChange }) => (
  <Item>
    <Item.Content>
      <Item.Header>State Transition</Item.Header>
      <Segment basic>
        <Dropdown
          search
          selection
          scrolling
          placeholder="Select state"
          options={options}
          onChange={onInputChange}
          loading={loading}
        />
        <Button color="blue" onClick={onClaimStateChange}>
          Save
        </Button>
      </Segment>
    </Item.Content>
  </Item>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/StateTransition/View.js